module.exports = __webpack_public_path__ + "41ed30e4dba75e9cb641f0239a88e3a7.pdf";